const TILE_CACHE = "cgland-tiles-v1";
const SUBS = ["a", "b", "c"];
export const MAX_TILES = 2000;

export function registerTileWorker() {
  if ("serviceWorker" in navigator) navigator.serviceWorker.register("/sw.js").catch(() => {});
}

const lng2x = (lng, z) => Math.floor(((lng + 180) / 360) * 2 ** z);
const lat2y = (lat, z) => { const r = (lat * Math.PI) / 180; return Math.floor(((1 - Math.log(Math.tan(r) + 1 / Math.cos(r)) / Math.PI) / 2) * 2 ** z); };

export function tileUrlsForBounds(bounds, zMin, zMax) {
  const [[s, w], [n, e]] = bounds;
  const urls = [];
  for (let z = zMin; z <= zMax; z++) {
    const x0 = lng2x(w, z), x1 = lng2x(e, z), y0 = lat2y(n, z), y1 = lat2y(s, z);
    for (let x = x0; x <= x1; x++) for (let y = y0; y <= y1; y++) urls.push(`https://${SUBS[(x + y) % 3]}.tile.openstreetmap.org/${z}/${x}/${y}.png`);
  }
  return urls;
}

export async function cacheTiles(urls, onProgress) {
  const cache = await caches.open(TILE_CACHE);
  let done = 0, failed = 0;
  const worker = async () => {
    while (urls.length) {
      const url = urls.shift();
      try {
        if (!(await cache.match(url))) {
          const res = await fetch(url, { mode: "no-cors", cache: "no-store" });
          await cache.put(url, res);
        }
      } catch { failed++; }
      done++;
      onProgress?.(done, failed);
    }
  };
  await Promise.all(Array.from({ length: 6 }, worker));
  return { done, failed };
}

export async function cacheStats() {
  if (!("caches" in window)) return { count: 0, supported: false };
  const cache = await caches.open(TILE_CACHE);
  const keys = await cache.keys();
  return { count: keys.length, supported: true };
}

export async function clearTileCache() {
  await caches.delete(TILE_CACHE);
  await caches.delete("cgland-data-v1");
}

// Warm the data cache: parcels, layer geometry/overlays and notes for the current filters (SW stores the responses).
export async function prefetchMapData(api, { district = "", q = "", layers = [] } = {}) {
  const token = localStorage.getItem("cgland_token");
  const jobs = [
    api.get("/map/access"), api.get("/map/parcels", { params: { district, q } }), api.get("/map/parcels"), api.get("/map/layers"), api.get("/map/notes"),
    ...layers.map((l) => (l.kind === "raster" ? fetch(`${api.defaults.baseURL}/map/layers/${l.id}/overlay.png?auth=${token}`) : api.get(`/map/layers/${l.id}/geojson`))),
  ];
  const results = await Promise.allSettled(jobs);
  return results.filter((r) => r.status === "fulfilled").length;
}

export async function dataCacheCount() {
  if (!("caches" in window)) return 0;
  const cache = await caches.open("cgland-data-v1");
  return (await cache.keys()).length;
}
